/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */

/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useState } from "react";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
//import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// About Us page sections
import NewsInformation from "pages/LandingPages/News/sections/NewsInformation";
// import Team from "pages/LandingPages/AboutUs/sections/Team";
// import Featuring from "pages/LandingPages/AboutUs/sections/Featuring";
// import Newsletter from "pages/LandingPages/AboutUs/sections/Newsletter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";
import TopAlert from "pages/LandingPages/TopAlert";

//import CardContent from "@mui/material/CardContent";


// Images
import bgImage from "assets/images/bg-presentation.jpg";

function News() {
  const [alertVisible, setAlertVisible] = useState(true);
  return (
    <>
      {alertVisible && <TopAlert onClose={() => setAlertVisible(false)} />}
      <Box sx={{ paddingTop: alertVisible ? "30px" : "0px" }}>
        <DefaultNavbar
          routes={routes}
          sticky
        />
        <MKBox
          minHeight="55vh"
          width="100%"
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
          }}
        >
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              {/* Card Wrapper */}
              {/* <Card
              sx={{
                backgroundColor: "grey.100", // Light grey background
                padding: 4,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: "center",
              }}
            >
              <CardContent> */}
              {/* Typography Inside the Card */}
              <MKTypography
                variant="h1"
                color="white" // Text color changed to black for contrast
                mt={-2}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Elections Nova Scotia
              </MKTypography>

              <MKTypography
                variant="h3"
                color="white"
                textAlign="center"
                px={{ xs: 2, lg: 6 }}
                mt={1}
              >
                Elections That Work For You
              </MKTypography>
              {/* </CardContent>
            </Card> */}
            </Grid>
          </Container>
        </MKBox>

        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Chéticamp-Margarees-Pleasant Bay By-election Information"
                  description={<>Release date: June 15, 2026
                    <br /><br />
                    Elections Nova Scotia – Election day for the Chéticamp-Margarees-Pleasant Bay by-election is Tuesday, June 23, 2026. 
                    <br /><br />
                    Early voting is available Monday to Saturday, 9 am to 6 pm, at the returning office, 51 Old Cabot Trail RD, Grand Étang. 
                    <br /><br />
                    This week on Thursday, June 18 and Friday, June 19, 2026, there will be extended hours for early voting until 8 pm. 
                    <br /><br />
                    There is no voting on Sundays. 
                    <br /><br />
                    On election day, Tuesday, June 23, 2026, voting will be open from 8 am to 8 pm and voters in Chéticamp-Margarees-Pleasant Bay may vote at their assigned voting location or the returning office.
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Bring ID When You Vote in the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 12, 2026
                    <br /><br />
                    Elections Nova Scotia – Voters in Chéticamp-Margarees-Pleasant Bay should bring their Voter Information Card (VIC) and ID with their name and current address when they vote in the by-election. Having a VIC and an ID makes voting fast and easy, but these are not necessary to vote. 
                    <br /><br />
                    Eligible voters in Chéticamp-Margarees-Pleasant Bay can register when they go to vote. If they do not have current ID with their correct name or address, they can take an oath to attest to their eligibility. 
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Community Polls Open for Early Voting in the Chéticamp-Margarees-Pleasant Bay By-election"
                  description={<>Release date: June 11, 2026
                    <br /><br />
                    Elections Nova Scotia – Two community poll locations will be available for early voting in Chéticamp-Margarees-Pleasant Bay by-election for the next three days from Thursday, June 11 to Saturday, June 13, 2026.
                    <br /><br />
                    Community polls will be held from 9 am to 6 pm at the following locations:
                    <br/><br/>
                    <ul>
                      <li>St. Patrick&apos;s Parish Hall, 6541 Cabot Trail, North East Margaree</li>
                      <li>Whale Interpretive Centre, 104 Harbour Rd, Pleasant Bay</li>
                    </ul>
                    <br />
                    Voters in Chéticamp-Margarees-Pleasant Bay can cast their ballot early using the secure e-Ballot system at the community polls or at the returning office continuous poll, 51 Old Cabot Trail RD, Grand Étang. 
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Voter Information Cards (VIC) for the Chéticamp-Margarees-Pleasant Bay By-election"
                  description={<>Release date: June 10, 2026
                    <br /><br />
                    Elections Nova Scotia – Personalized Voter Information Cards (VIC), were sent by mail to all registered voters in the electoral district of Chéticamp-Margarees-Pleasant Bay last week. VICs have information on where and when to vote in the current by-election. 
                    <br /><br />
                    Elections Nova Scotia has redesigned the VIC to make it more accessible for voters. Each registered voter received a personalized postcard style VIC. 
                    <br /><br />
                    Eligible voters can vote without a VIC. A voter can be added to the Nova Scotia registry of Electors when they vote with ID or they can take an oath to attest to their eligibility. If there are errors in the VIC a voter receives, they can bring it when they come to vote and have their information updated. 
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Community Polls for the Chéticamp-Margarees-Pleasant Bay By-election Begin Tomorrow"
                  description={<>Release date: June 10, 2026
                    <br /><br />
                    Elections Nova Scotia – Two community poll locations will be available for early voting in Chéticamp-Margarees-Pleasant Bay by-election for the next three days from Thursday, June 11 to Saturday, June 13, 2026.
                    <br /><br />
                    Community polls will be held from 9 am to 6 pm at the following locations:
                    <br/><br/>
                    <ul>
                      <li>St. Patrick&apos;s Parish Hall, 6541 Cabot Trail, North East Margaree</li>
                      <li>Whale Interpretive Centre, 104 Harbour Rd, Pleasant Bay</li>
                    </ul>
                    <br />
                    Voters in Chéticamp-Margarees-Pleasant Bay can cast their ballot early using the secure e-Ballot system at the community polls or at the returning office continuous poll, 51 Old Cabot Trail RD, Grand Étang. 
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Vote Remotely in the Chéticamp-Margarees-Pleasant Bay By-election"
                  description={<>Release date: June 9, 2026
                    <br /><br />
                    Elections Nova Scotia – Eligible voters in Chéticamp-Margarees-Pleasant Bay can apply to vote remotely by write-in ballot. 
                    <br /><br />
                    If voters need assistance, a write-in ballot team can visit them at home. Voters can arrange a home visit by calling 1-866-232-0016. Voters can also ask someone they trust who is at least 18 years old to act as their agent to help them apply for and return their write-in ballot. 
                    <br/><br/>
                    Once a write-in ballot application is approved, the voter will be sent a write-in ballot kit with instructions.
                    <br /><br />
                    It is important for voters to understand the deadlines to return their completed write-in ballot kit so it can be counted. 
                    <br /><br />
                    The deadline to apply for a write-in ballot by mail is Saturday, June 13, 2026, by 6pm. 
                    <br /><br />
                    All write-in ballot kits must be returned before the close of voting on election day to be counted, that is, 8 pm on Tuesday, June 23, 2026. Voters are asked to please allow adequate time so their write-in ballot can be returned by the deadline.
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Early Voting Opportunities This Week In Chéticamp-Margarees-Pleasant Bay"
                  description={<>Release date: June 9, 2026
                    <br /><br />
                    Elections Nova Scotia – Voters in Chéticamp-Margarees-Pleasant Bay will have three early voting opportunities to choose from over three days this week. Voters may cast their ballot before election day at either the returning office or at one of two community poll locations.
                    <br /><br />
                    Early voting is available Monday to Saturday, 9 am to 6 pm, at the returning office, 51 Old Cabot Trail RD, Grand Étang. On Thursday, June 18 and Friday, June 19, 2026, there will be extended hours at the returning office until 8 pm. 
                    <br/><br/>
                    Early voting will also be available this week from Thursday, June 11 to Saturday, June 13, 2026 at two community polls:
                    <br /><br />
                    <ul>
                      <li>St. Patrick&apos;s Parish Hall, 6541 Cabot Trail North East Margaree</li>
                      <li>Whale Interpretive Centre, 104 Harbour Rd Pleasant Bay</li>
                    </ul>
                    <br />
                    There is no voting on Sundays
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Voters in Chéticamp-Margarees-Pleasant Bay should watch their mailboxes this week for their Voter Information Card (VIC)"
                  description={<>Release date: June 8, 2026
                    <br /><br />
                    Elections Nova Scotia – Registered voters in Chéticamp-Margarees-Pleasant Bay will receive a Voter Information Card (VIC) in the mail this week with information on where and when to vote in the by-election. 
                    <br /><br />
                    Elections Nova Scotia has redesigned the VIC to make it more accessible for voters. Each registered voter will receive a personalized postcard style VIC. 
                    <br/><br/>
                    Eligible voters in Chéticamp-Margarees-Pleasant Bay can vote without a VIC. A voter can be added to the Nova Scotia registry of Electors when they vote with ID or they can take an oath to attest to their eligibility. If there are errors in the VIC a voter receives, they can bring it with them when they vote and have their information updated.
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Voting Options for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 5, 2026
                    <br /><br />
                    Elections Nova Scotia – Election day in Chéticamp-Margarees-Pleasant Bay is Tuesday, June 23, 2026, but there are 25 days of voting in the by-election. Voters can vote early at a voting location or apply to vote remotely using a write-in ballot.  
                    <br /><br />
                    All registered voters in Chéticamp-Margarees-Pleasant Bay will receive a personal Voter Information Card (VIC) in the mail outlining where and when they can vote. Eligible voters do not need a VIC to vote. 
                    <br/><br/>
                    Eligible voters can be added to the voters list during the by-election when they go to vote. Voters in Chéticamp-Margarees-Pleasant Bay can also use the ‘Where do I Vote?’ tool on the Elections Nova Scotia website (electionsnovascotia.ca) to find a voting location. 
                    <br /><br />
                    Early voting is available Monday to Saturday, 9 am to 6 pm, at the returning office, 51 Old Cabot Trail RD, Grand Étang. On Thursday, June 18 and Friday, June 19, 2026, there will be extended hours at the returning office until 8 pm. 
                    <br /><br />
                    Early voting will also be available from Thursday, June 11 to Saturday, June 13, 2026 at the community polls:
                    <br /><br />
                    <ul>
                      <li>St. Patrick&apos;s Parish Hall, 6541 Cabot Trail North East Margaree</li>
                      <li>Whale Interpretive Centre, 104 Harbour Rd Pleasant Bay</li>
                    </ul>
                    <br />
                    There is no voting on Sundays. 
                    <br /><br />
                    Eligible voters in Chéticamp-Margarees-Pleasant Bay can also apply to vote remotely by write-in ballot. It is important for voters to understand the deadlines to return their completed write-in ballot kit so it can be counted. Voters are asked to please allow adequate time so their write-in ballot can be returned by the deadline.
                    <br /><br />
                    The deadlines to apply for a write-in ballot by mail is Saturday, June 13, 2026, by 6 pm. 
                    <br /><br />
                    The deadlines apply for a write-in ballot in Person and by agent is Tuesday, June 23, 2026, at 3 pm.
                    <br /><br />
                    A write-in ballot team can also visit a voter at home. Voters can arrange a home visit by calling 1-866-232-0016. 
                    <br /><br />
                    All write-in ballot kits must be returned before the close of voting on election day to be counted, that is, 8 pm on Tuesday, June 23, 2026 
                    <br /><br />
                    On election day, Tuesday, June 23, 2026, voting will be open from 8 am to 8 pm. On election day, voters in Chéticamp-Margarees-Pleasant Bay may vote at their assigned voting location or the returning office.
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Chéticamp-Margarees-Pleasant Bay Voters Can Apply to Vote Remotely"
                  description={<>Release date: June 5, 2026
                    <br /><br />
                    Elections Nova Scotia – Eligible voters in Chéticamp-Margarees-Pleasant Bay can apply to vote remotely by write-in ballot. 
                    <br /><br />
                    Voters can also ask someone they trust who is at least 18 years old to act as their agent to help them apply for and return their write-in ballot. 
                    <br/><br/>
                    A write-in ballot team can also visit a voter at home. Voters can arrange a home visit by calling 1-866-232-0016. 
                    <br /><br />
                    Once a write-in ballot application is approved, the voter will be sent a write-in ballot kit with instructions.
                    <br></br>
                    It is important for voters to understand the deadlines to return their completed write-in ballot kit so it can be counted. Voters are asked to please allow adequate time so their write-in ballot can be returned by the deadline.
                    <br /><br />
                    The deadlines to apply for a write-in ballot by mail is Saturday, June 13, 2026, by 6pm. 
                    <br /><br />
                    The deadlines apply for a write-in ballot in Person and by agent is Tuesday, June 23, 2026, at 3 pm.
                    <br /><br />
                    All write-in ballot kits must be returned before the close of voting on election day to be counted, that is, 8 pm on Tuesday, June 23, 2026 
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Voter Information Cards (VIC) are in the Mail for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 4, 2026
                    <br /><br />
                    Elections Nova Scotia – All registered voters in the electoral district of Chéticamp-Margarees-Pleasant Bay will receive a personal Voter Information Card (VIC) in the mail for the current by-election. VICs provide information on where and when to vote. The VICs for the Chéticamp-Margarees-Pleasant Bay by-election are in the mail now and should arrive in mailboxes later this week.
                    <br /><br />
                    Elections Nova Scotia has redesigned the VIC to make it easier for voters. The VIC is postcard style with one personalized card for each registered voter. An accessibly review was part of the redesign process to ensure the card is easy for all voters to read and understand. 
                    <br/><br/>
                    Eligible voters in Chéticamp-Margarees-Pleasant Bay can vote without a VIC. A voter can be added to the Nova Scotia registry of Electors when they vote with ID or they can take an oath to attest to their eligibility. 
                    <br /><br />
                    If there are errors in the VIC a voter receives, they can bring it with them when they vote and have their information updated.
                    <br></br>
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="e-Balloting begins in the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 4, 2026
                    <br /><br />
                    Elections Nova Scotia – Today, Thursday, June 4, 2026, voters in Chéticamp-Margarees-Pleasant Bay will begin to cast their ballots in the current by-election on a secure tablet using Elections Nova Scotia’s e-Ballot system. 
                    <br /><br />
                    To date (from the start of early voting on Tuesday, May 26, 2026, until the close of polls yesterday, 6 pm on Wednesday, June 3, 2026) 295 early votes were cast using write-in ballot in the Chéticamp-Margarees-Pleasant Bay by-election. 
                    <br/><br/>
                    As of today, Thursday, June 4, 2026, early voting will be done by e-Ballot. 
                    <br /><br />
                    The safe e-Ballot system allows voters to select the candidate of their choice on a secure tablet. E-Balloting allows fast and secure counting of early votes when the polls close on election night. This means the results of the Chéticamp-Margarees-Pleasant Bay by-election will be returned quickly and efficiently. 
                    <br></br>
                    On election day, Tuesday, June 23, 2026, voting in Chéticamp-Margarees-Pleasant Bay will be done using traditional paper ballots. 
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Nominations Closed for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 3, 2026
                    <br /><br />
                    Elections Nova Scotia – Candidate nominations for the Chéticamp-Margarees-Pleasant Bay by-election closed at 2pm today, Wednesday, June 3, 2026. The following 4 nominated candidates will be on the ballot:
                    <br /><br />
                    Nik Boisvert, Green Party of Nova Scotia (Green Party of NS)<br/>
                    Claude Bourgeois, Progressive Conservative Association of Nova Scotia (PC) <br/>
                    Denis Cormier, Nova Scotia Liberal Party (Liberal Party) <br/>
                    Trevor Poirier, Nova Scotia New Democratic Party (NSNDP)<br/>
                    <br/><br/>
                    The candidate names, their party affiliation, and the name of their official agent are also available on the Elections Nova Scotia website at electionsnovascotia.ca.
                    <br /><br />
                    Candidates must complete official nomination forms and have them accepted by the returning officer to have their name added to the ballot. The Nomination process includes the following:
                    <br></br>
                    <ul>
                      <li>Filing a completed Candidate nomination form (form 105) with the returning officer in the electoral district in which the candidate wishes to run</li>
                      <li>Providing the name and contact information of their appointed official agent</li>
                      <li>Providing the name and contact information of their appointed auditor, who must be a public accountant licensed by CPANS to audit</li>
                      <li>Providing nomination papers signed by at least five electors, from the electoral district in which the candidate wishes to run, who are eligible to vote</li>
                      <li>Filing an endorsement letter from the Party leader if the candidate is running for a registered political party</li>
                    </ul>
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="E-Balloting will Begin Tomorrow in the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 3, 2026
                    <br /><br />
                    Elections Nova Scotia – Nominations for the Chéticamp-Margarees-Pleasant Bay by-election close today, Wednesday, June 3, 2026, at 2 pm. 
                    <br /><br />
                    Early voting before the close of nominations is done using the write-in ballot. When nominations are closed, early voting will switch tomorrow to Elections Nova Scotia’s secure e-Ballot system.
                    <br/><br/>
                    E-Balloting is in-person digital voting at a voting location using a secure tablet. The e-Balloting system is safe and allows voters to select the candidate of their choice on a secure tablet behind the voting screen. 
                    <br /><br />
                    E-Balloting allows fast and secure counting of early votes when the polls close on election night. This means the results of the Chéticamp-Margarees-Pleasant Bay by-election will be returned quickly and efficiently. 
                    <br /><br />
                    E-Balloting will only be used after the close of nominations for early voting prior to election day. Traditional paper ballots will be used for voting on election day in Chéticamp-Margarees-Pleasant Bay, Tuesday, June 23, 2026 
                    <br /><br />
                    E-Balloting is not internet voting. E-Balloting takes place in-person at a voting location on a secure tablet while internet voting is remote voting. Internet voting will not be used in the Chéticamp-Margarees-Pleasant Bay by-election. 
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Candidate Nominations for the Chéticamp-Margarees-Pleasant Bay by-election Close Tomorrow"
                  description={<>Release date: June 2, 2026
                    <br /><br />
                    Elections Nova Scotia – Elections Nova Scotia would like to remind voters in Chéticamp-Margarees-Pleasant Bay that the deadline for candidate nominations for the current by-election is <b>2 pm tomorrow, Wednesday, June 3, 2026</b>. 
                    <br /><br />
                    The Elections Act requires nominations to close 20 days before election day, which will be Tuesday, June 23, 2026. 
                    <br/><br/>
                    Candidates must complete official nomination forms and have them accepted by the returning officer to have their name added to the ballot. The Nomination process includes the following:
                    <br /><br />
                    <ul>
                      <li>Filing a completed Candidate nomination form (form 105) with the returning officer in the electoral district in which the candidate wishes to run </li>
                      <li>Providing the name and contact information of their appointed official agent</li>
                      <li>Providing the name and contact information of their of their appointed auditor, who must be a public accountant licensed by CPANS to audit</li>
                      <li>Providing nomination papers signed by at least five electors, from the electoral district in which the candidate wishes to run, who are eligible to vote</li>
                      <li>Filing an endorsement letter from the Party leader if the candidate is running for a registered political party</li>
                    </ul>
                    <br /><br />
                    Early voting in the Chéticamp-Margarees-Pleasant Bay by-election before the close of candidate nominations is done using the write-in ballot. Following the close of candidate nominations, early voting for the Chéticamp-Margarees-Pleasant Bay by-election will be done using Elections Nova Scotia’s secure e-Ballot system. Traditional paper ballots will be used on election day. 
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Call for Election Workers in Chéticamp-Margarees-Pleasant Bay"
                  description={<>Release date: June 2, 2026
                    <br /><br />
                    Elections Nova Scotia – It takes a lot of people and effort to make a by-election run smoothly. Elections Nova Scotia needs dedicated workers to facilitate voting during the current by-election in the electoral district of Chéticamp-Margarees-Pleasant Bay.
                    <br /><br />
                    People 18 years and older who would like to work the Chéticamp-Margarees-Pleasant Bay by-election are asked to please call 1-866-232-0016. 
                    <br/><br/>
                    There are also some jobs available for people ages 16 to 18. 
                    <br /><br />
                    Bilingualism is an asset for workers in this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Voting Information for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 1, 2026
                    <br /><br />
                    Elections Nova Scotia – A by-election is underway to elect the member of the Nova Scotia Legislative Assembly for the electoral district of Chéticamp-Margarees-Pleasant Bay. Election day is Tuesday, June 23, 2026 but early voting and remote voting are available. 
                    <br /><br />
                    Eligible voters in the Chéticamp-Margarees-Pleasant Bay by-election must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay, and have lived in Nova Scotia since November 23, 2025 (six months before the writ of election was issued).
                    <br/><br/>
                    All registered voters in Chéticamp-Margarees-Pleasant Bay will receive a personal Voter Information Card (VIC) in the mail outlining where and when they can vote. Eligible voters do not need a VIC to vote. 
                    <br /><br />
                    Early voting is available Monday to Saturday, 9 am to 6 pm, at the Returning Office, 51 Old Cabot Trail RD, Grand Étang Chéticamp-Margarees-Pleasant Bay. On Thursday, June 18 and Friday, June 19, 2026 there will be extended hours until 8 pm for voting at early voting at the returning office. 
                    <br /><br />
                    Early voting will also be available from Thursday, June 11 to Saturday, June 13, 2026 at the community polls:
                    <br /><br />
                    <ul>
                      <li>St. Patrick&apos;s Parish Hall, 6541 Cabot Trail North East Margaree</li>
                      <li>Whale Interpretive Centre, 104 Harbour Rd Pleasant Bay</li>
                    </ul>
                    <br /><br />
                    There is no voting on Sundays. 
                    <br /><br />
                    Eligible voters in Chéticamp-Margarees-Pleasant Bay can apply to vote remotely using a write-in ballot or arrange to have a write-in ballot team visit them at home. Call 1-866-232-0016 for assistance with remote voting.  
                    <br /><br />
                    Early voting in the Chéticamp-Margarees-Pleasant Bay by-election will be done by write-in ballot until the close of candidate nominations on Wednesday, June 3, 2026 . After the close of nominations, safe secure e-Balloting will be used for early voting in the Chéticamp-Margarees-Pleasant Bay by-election. On election day traditional paper ballots will be used. 
                    <br /><br />
                    On election day, Tuesday, June 23, 2026, voting will be open from 8 am to 8 pm. On election day, voters in Chéticamp-Margarees-Pleasant Bay may vote at their assigned voting location or the returning office.
                    <br /><br />
                    <b>Voters in Chéticamp-Margarees-Pleasant Bay that have questions about the by-election can call 1-866-232-0016.</b>
                    <br /><br />
                    Please note, media interviews are available in French for this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Candidate Nominations for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: June 1, 2026
                    <br /><br />
                    Elections Nova Scotia – The deadline for candidate nominations for the Chéticamp-Margarees-Pleasant Bay by-election is <b>Wednesday, June 3, 2026, at 2 pm</b>.
                    <br /><br />
                    Before an election is called candidates may register with Elections Nova Scotia so they can begin to incur expenses. 
                    <br/><br/>
                    Now that the Chéticamp-Margarees-Pleasant Bay by-election is underway, candidates must complete official nominations forms and have them accepted by the Returning Officer to have their name added to the ballot. The Nomination process includes the following:
                    <br /><br />
                    <ul>
                      <li>Filing a completed Candidate nomination form (form 105) with the returning officer in the electoral district in which the candidate wishes to run </li>
                      <li>Providing the name and contact information of their appointed official agent</li>
                      <li>Providing the name and contact information of their appointed auditor, who must be a public accountant licensed by CPANS to audit</li>
                      <li>Providing nomination papers signed by at least five electors, from the electoral district in which the candidate wishes to run, who are eligible to vote </li>
                      <li>Filing an endorsement letter from the Party leader if the candidate is running for a registered political party</li>
                    </ul>
                    <br />
                    Elections Nova Scotia’s website has been updated to include a list of candidates currently nominated. That list will continue to be updated as nominations are received. 
                    <br /><br />
                    Early voting before the close of candidate nominations in the Chéticamp-Margarees-Pleasant Bay by-election, is done using the write-in ballot. Early voting after the close of nominations will be done by secure e-Balloting.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Campaign Access to Multi-unit Buildings"
                  description={<>Release date: May 29, 2026
                    <br /><br />
                    Elections Nova Scotia – Elections Nova Scotia would like to remind landlords and administrators of multi-unit buildings and condominiums in the electoral district of Chéticamp-Margarees-Pleasant Bay that enumerators and candidates must be given access during the by-election that is currently underway. 
                    <br /><br />
                    It is an offence under the Elections Act to impede a candidate when lawfully campaigning or an enumerator when gathering information for the Register of Electors during a by-election.
                    <br/><br/>
                    Elections Nova Scotia has a policy on campaign access to multi-unit buildings to help provide clarity and understanding for landlords, tenants, and candidates. The policy is available on the Elections Nova Scotia website at https://electionsnovascotia.ca.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Campaign Signage and Election Advertising"
                  description={<>Release date: May 29, 2026
                    <br /><br />
                    Elections Nova Scotia – Now that the Chéticamp-Margarees-Pleasant Bay by-election is underway in Nova Scotia, people will see campaign signs or be asked to place a sign on their property. 
                    <br /><br />
                    All advertising by candidates, parties or third parties, which promotes or opposes any candidate or registered party or takes a position on an issue with which a candidate or registered party is associated, is election advertising. Election advertising by candidates and parties must bear the words “authorized by the official agent for [name of candidate or registered party].”
                    <br/><br/>
                    During a by-election, knowingly spreading false statements about a candidate’s character or conduct during an election is an offence under the Elections Act. 
                    <br /><br />
                    The placement of signs is subject to provincial and municipal laws and regulations. The Elections Act allows a tenant or owner in a multiple-unit residence or a condominium residence to post election signs on their own property. The size and type of poster may be subject to reasonable regulation by the landlord or condominium corporation.
                    <br /><br />
                    Third party advertising is election advertising by a group or individual who is not directly involved in the election. Third parties that spend $500 or more must register with Elections Nova Scotia and their ads must include an authorization statement.
                    <br /><br />
                    Municipal rules vary; please check with your municipal authority if you have concerns. Areas along highways, including some within municipalities, are managed by the Department of Public Works. People who have questions about signs along highways may call a toll-free number 1-844-696-7737 or email dpw-occ@novascotia.ca.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Remote Voting by Write-in Ballot in the Chéticamp-Margarees-Pleasant Bay By-election"
                  description={<>Release date: May 28, 2026
                    <br /><br />
                    Elections Nova Scotia – Voters in Chéticamp-Margarees-Pleasant Bay can apply to vote remotely using a write-in ballot in the current by-election.
                    <br /><br />
                    Voters in Chéticamp-Margarees-Pleasant Bay can call 1-866-232-0016 to have a write-in ballot application sent to them. They can also arrange to have a write-in ballot team visit their home. Voters who need assistance can also have a trusted friend or family member act as the voter’s agent to help them apply for a write-in ballot kit. 
                    <br/><br/>
                    Once a voter has applied to vote by write-in ballot, that is the method of voting they must use. 
                    <br /><br />
                    The deadline to apply for a write-in ballot by mail is Saturday, June 13, 2026, by 6 pm. 
                    <br /><br />
                    The application deadline for a write-in ballot in-person or by agent is Tuesday, June 23, 2026, by 3 pm. 
                    <br /><br />
                    All completed write-in ballots must be returned by 8 pm on election day, Tuesday, June 23, 2026, to be counted.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Call for Election Workers in Chéticamp-Margarees-Pleasant Bay"
                  description={<>Release date: May 27, 2026
                    <br /><br />
                    Elections Nova Scotia – It takes a lot of people and effort to make a by-election run smoothly. Elections Nova Scotia needs dedicated workers to facilitate voting during the current by-election in the electoral district of Chéticamp-Margarees-Pleasant Bay. 
                    <br /><br />
                    People 18 years and older who would like to work the Chéticamp-Margarees-Pleasant Bay by-election are asked to please call 1-866-232-0016. 
                    <br/><br/>
                    There are also some jobs available for people ages 16 to 18. 
                    <br /><br />
                    Bilingualism is an asset for workers in this by-election.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Eligible Voters Encouraged to Register for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: May 27, 2026
                    <br /><br />
                    Elections Nova Scotia – Elections Nova Scotia maintains a Register of Electors of anyone eligible to vote in a Nova Scotia provincial general election or by-election. The Register is updated regularly and there are several ways to be added to the list. Eligible voters can register any time online to ensure they are on the Nova Scotia Registry of Electors. 
                    <br /><br />
                    Eligible voters in the electoral district of Chéticamp-Margarees-Pleasant Bay who are not already on the list of electors are encouraged to register to vote in the by-election to be held Tuesday, June 23, 2026. 
                    <br/><br/>
                    New voters include young adults 18 years of age or older, new Canadian citizens, or voters who have moved to Nova Scotia and have not yet voted in a provincial election. 
                    <br /><br />
                    Though being registered before arriving at a voting location is not required, those who are registered are sent a personalized Voter Information Card (VIC) with information on where and when to vote. 
                    <br /><br />
                    To be eligible to vote in the Chéticamp-Margarees-Pleasant Bay by-election, voters must be a Canadian citizen, 18 years or over on Tuesday, June 23, 2026, reside in the electoral district of Chéticamp-Margarees-Pleasant Bay and have lived in Nova Scotia for at least six months from the day the by-election was called (since November 23, 2025). 
                    <br /><br />
                    Please note, media interviews are available in French for this by-election. 
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Early Voting Has Begun Ahead of Schedule for the Chéticamp-Margarees-Pleasant Bay By-election"
                  description={<>Release date: May 26, 2026
                    <br /><br />
                    Elections Nova Scotia - A by-election is underway in the electoral district of Chéticamp-Margarees-Pleasant Bay. Election day will be <b>Tuesday, June 23, 2026</b>.
                    <br /><br />
                    Early voting has opened today, May 26, 2026 (day 28 of the by-election calendar), and is now available at the returning office continuous poll located at 51 Old Cabot Trail RD, Grand Étang. 
                    <br/><br/>
                    The Elections Act requires early voting to begin on day 27 of the election calendar but allows early voting to start before day 27 if the returning office is ready. The Chéticamp-Margarees-Pleasant Bay returning office is up and running so eligible voters in the district can now start to cast their ballots. 
                    <br /><br />
                    There will now be 25 days of voting in this by-election. 
                    <br /><br />
                    Early voting is available every Monday to Saturday from 9 am – 6 pm. 
                    <br />
                    Early voting is closed on Sundays. 
                    <br /><br />
                    On Thursday, June 18 and Friday, June 19, 2026, there are extended hours for early voting from 9 am – 8 pm. 
                    <br /><br />
                    Before the close of candidate nominations, at 2 pm on Wednesday, June 3, 2026, the write-in ballot will be used for early voting. After candidate nominations close, e-Balloting will be used for early voting in the Chéticamp-Margarees-Pleasant Bay by-election. 
                    <br /><br />
                    Voters can also arrange to have a write-in ballot team visit them at home. 
                    <br /><br />
                    If you are interested in working the Chéticamp-Margarees-Pleasant Bay by-election or need more information, please call 1-866-232-0016.
                    <br /><br />
                    Please note, media interviews are available in French for this by-election. 
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Candidate and Party Spending Limits for the Chéticamp-Margarees-Pleasant Bay by-election"
                  description={<>Release date: May 26, 2026
                    <br /><br />
                    Elections Nova Scotia – Listed below are the candidate and party spending limits and reimbursements for the Chéticamp-Margarees-Pleasant Bay by-election to be held on Tuesday, June 23, 2026.  
                    <br /><br />
                    The following amounts are determined according to the Elections Act (updated to include CPI adjustments):
                    <br/><br/>
                    <b>Initial Number of Electors</b>: 3,923 (as of May 24, 2026)
                    <br /><br />
                    <b>Candidate Spending Limit*</b>: $31,705
                    <br />
                    <b>Candidate Reimbursement Limit</b>: $7,926.25
                    <br />
                    <b>Registered Party Spending Limit</b>: $8,086.35
                    <br />
                    <b>Third Party Spending Limit</b>: $2,825.81
                    <br /><br />
                    * Candidate spending limit may be adjusted based on the number of electors on the Final List of Electors. The final list will be completed after election day.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Candidate Nomination Fee Not Required for the Chéticamp-Margarees-Pleasant Bay by-election "
                  description={<>Release date: May 25, 2026
                    <br /><br />
                    Elections Nova Scotia – Chief Electoral Officer (CEO) Dorothy Rice has issued a directive that the $200 candidate nomination fee is not required for the Chéticamp-Margarees-Pleasant Bay by-election. 
                    <br /><br />
                    Individuals who intend to run as a candidate can register with Elections Nova Scotia prior to a writ of election being issued. This allows the candidate to accept contributions and incur expenses. 
                    <br/><br/>
                    Now that the Chéticamp-Margarees-Pleasant Bay by-election is underway (election day is Tuesday, June 23, 2026), candidates must complete official nominations forms and have them accepted by the Returning Officer to have their name added to the ballot. The Nomination process includes the following:
                    <br /><br />
                    <ul style={{ paddingLeft: "40px" }}>
                      <li>Filing a completed Candidate nomination form (form 105) with the returning officer in the electoral district in which the candidate wishes to run </li>
                      <li>Providing the name and contact information of their appointed official agent </li>
                      <li>Providing the name and contact information of their appointed auditor, who must be a public accountant licensed by CPANS to audit </li>
                      <li>Providing nomination papers signed by at least five electors, from the electoral district in which the candidate wishes to run, who are eligible to vote </li>
                      <li>Filing an endorsement letter from the Party leader if the candidate is running for a registered political party </li>
                    </ul>
                    <br /><br />
                    The deadline for candidate nominations for the Chéticamp-Margarees-Pleasant Bay by-election is Wednesday, June 3, 2026, at 2 pm. 
                    <br /><br />
                    Elections Nova Scotia publishes the names of nominated candidates and the names of the official agent for their campaign on the ENS website at <a href="https://electionsnovascotia.ca">https://electionsnovascotia.ca</a> as nominations are received. 
                    <br /><br />
                    Early voting in the Chéticamp-Margarees-Pleasant Bay by-election before the close of candidate nominations will be done by write-in ballot. Following the close of candidate nominations, early voting for the Chéticamp-Margarees-Pleasant Bay by-election will be done using Elections Nova Scotia’s secure e-Ballot system. 
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Chéticamp-Margarees-Pleasant Bay by-election "
                  description={<>Release date: May 25, 2026
                    <br /><br />
                    Elections Nova Scotia – A by-election is underway in the new electoral district of Chéticamp-Margarees-Pleasant Bay. Election day will be <b>Tuesday, June 23, 2026</b>, but voters can voter early and remotely by write-in ballot. In total there will be 24 days of voting available to electors in Chéticamp-Margarees-Pleasant Bay
                    <br /><br />
                    Early voting will begin on Wednesday, May 27, 2026, at the returning office, 51 Old Cabot Trail RD, Grand Étang.
                    <br/><br/>
                    E-Balloting will be used for early voting in the Chéticamp-Margarees-Pleasant Bay by-election following the close of candidate nominations at 2 pm on Wednesday, June 3, 2026. Before the close of candidate nominations, the write-in ballot will be used for early voting.
                    <br /><br />
                    The e-Balloting system is safe and allows voters to select the candidate of their choice on a secure tablet. E-Balloting allows fast and secure counting of early votes when the polls close on election night. This means the results of the Chéticamp-Margarees-Pleasant Bay by-election will be returned quickly and efficiently.
                    <br /><br />
                    Traditional paper ballots will be used for voting on election day. E-Balloting will only be offered during early voting after the close of candidate nominations prior to election day in the Chéticamp-Margarees-Pleasant Bay by-election.
                    <br /><br />
                    E-Balloting is not internet voting. Both are electronic forms of voting, but e-Balloting takes place in-person at a voting location on a secure tablet while internet voting facilitates remote voting using the internet. Internet voting will not be used in the Chéticamp-Margarees-Pleasant Bay by-election.
                    <br /><br />
                    To be eligible to vote in the Chéticamp-Margarees-Pleasant Bay by-election, voters must be 18 years of age or older on Tuesday, June 23, 2026, a Canadian citizen, have lived in Nova Scotia since November 23, 2025, and reside in the electoral district of Chéticamp-Margarees-Pleasant Bay.
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br/><br/>
                    Please note, media interviews are available in French for this by-election. 
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                    <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Chéticamp-Margarees-Pleasant Bay by-election Called "
                  description={<>Release date: May 24, 2026
                    <br /><br />
                    Elections Nova Scotia – The Chief Electoral Officer (CEO), Dorothy Rice, has received an order from the Governor in Council for a by-election in the new electoral district of Chéticamp-Margarees-Pleasant Bay. The CEO has issued a writ of election for Chéticamp-Margarees-Pleasant Bay and election day will be Tuesday, June 23, 2026.
                    <br /><br />
                    Legislation was introduced in February 2026 to create a new exceptional electoral district called Chéticamp-Margarees-Pleasant Bay out of the existing Inverness electoral district. Amendments to the House of Assembly Act implement the recommendations of the 2025 Electoral Boundaries Commission, which released its final report January 30, 2026. 
                    <br /><br />
                    Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit https://electionsnovascotia.ca or follow us on Facebook, Bluesky, and X @electionsns.
                    <br/><br/>
                    Please note, media interviews are available in French for this by-election. 
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                     <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                   <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Elections That Work For You"
                  description={<>Release date: May 24, 2026
                    <br /><br />
                    Elections Nova Scotia – A by-election has been called in the new electoral district of Chéticamp-Margarees-Pleasant Bay. Nova Scotians who are 18 years or older, a Canadian citizen, have lived in the province for 6 months, and currently reside in the electoral district of Chéticamp-Margarees-Pleasant Bay can vote in this by-election. Election day is Tuesday, June 23, 2026, but voters can vote early. 
                    <br /><br />
                    “Voters in Chéticamp-Margarees-Pleasant Bay can count on Elections Nova Scotia to deliver on our mandate by providing a fair and balanced by-election,” says Dorothy Rice, Chief Electoral Officer of Nova Scotia, “We offer a variety of voting options because we want the electoral process to be accessible so all voters can participate in democracy.”
                    <br /><br />
                    There are 24 days available to vote in the Chéticamp-Margarees-Pleasant Bay by-election. Early voting will begin on Wednesday, May 27, 2026, at the returning office, 51 Old Cabot Trail RD, Grand Étang. 
                    <br/><br/>
                    Early voting after the close of candidate nominations on Wednesday, June 3, 2026, will be done using Elections Nova Scotia’s new secure e-Ballot system. e-Ballot allows voters to cast their vote on a secure tablet in-person at an early voting location. Early voting before the close of candidate nominations will be done by paper ballot, using the write-in ballot.
                    <br/><br/>
                    Write-in ballot is the remote voting option for voters in the Chéticamp-Margarees-Pleasant Bay by-election. Voters can apply to vote using a write-in ballot. A trusted friend of family member can act as an agent to assist a voter with their write-in ballot application. Returning offices call also make arrangements for a write-in ballot team to visit voters at their home. 
                    <br/><br/>
                    On election day, Tuesday, June 23, 2026, voters in Chéticamp-Margarees-Pleasant Bay must vote at their assigned voting location or the returning office. Elections day voting will be done on traditional paper ballots. Polls will be open on election day from 8 am – 8pm.
                    <br/><br/>
                    Please note, media interviews are available in French for this by-election. 
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />              
                    Elections Nova Scotia
                    <br/>
                     <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                   <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Elections Nova Scotia Continues Strategic Direction and Outreach Strategy"
                  description={<>Release date: April 14, 2026
                    <br /><br />
                    Elections Nova Scotia – Elections Nova Scotia (ENS) has released a refreshed strategic plan that will guide the organization over the next four years (2026-2030). ENS has also developed an outreach strategy action plan in collaboration with our IDEAs partners (inclusion, diversity, equity and accessibility) to guide our outreach work for the 43rd Provincial General Election when it is called. 
                    <br /><br />
                    Following the Provincial General Election in 2024, ENS reviewed its objectives and sought input to help improve electoral services for Nova Scotians. Consultation to shape ENS’s strategic direction included feedback from staff and returning officers as well as input from stakeholders, such as registered political parties, IDEAS partners (Inclusion Diversity, Equity and Accessibility), and the public. 
                    <br /><br />
                    “This refreshed plan builds on the foundation established in our 2022-2026 Strategic Plan, reaffirming our goals while incorporating enhancements informed by lessons learned,” says Dorothy Rice, Chief Electoral Officer. “We plan to stay the course and continue our strategic path to modernize the democratic process, enabling voters to access services and vote in ways that suit their needs.”
                    <br /><br />
                    ENS remains committed to continued relationship building with partners and stakeholders, ensuring electoral systems are secure, and streamlining processes to deliver positive experiences for all Nova Scotian voters. Equally important is ENS’s commitment to fostering inclusive and supportive work environments where staff, election workers, and volunteers can thrive and succeed.
                    <br /><br />
                    Developing a strategic plan helps create certainty in the uncertain environment in which ENS must plan for to deliver elections. The strategic plan is posted on the ENS website at electionsnovascotia.ca. 
                    <br /><br />
                    ENS is also committed to building relationships and partnerships with stakeholders to enhance the electoral process for all Nova Scotians through inclusion, diversity, equity, and access. ENS’s approach to outreach is long-term, requiring ongoing collaboration, support, and dedication. Together with our IDEAs partners, ENS will engage in the work outlined in the outreach strategy action plan to create change for underserved voters across Nova Scotia.
                    <br /><br />
                    “We have heard loud and clear that while progress has been made, challenges remain for underserved voters when accessing the electoral process,” says Rice. “Our Outreach Strategy Action Plan is not just about recognizing those challenges; it is about taking concrete steps to address them.”
                    <br /><br />
                    The outreach strategy action plan is also posted on the ENS website at electionsnovascotia.ca. 
                    <br /><br />
                    ENS is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit electionsnovascotia.ca or follow us on Facebook, X, Bluesky, and Instagram.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />
                   
                    Elections Nova Scotia
                    <br/>
                     <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>                  
                   <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Elections Nova Scotia Releases Financial Report on the 42nd Provincial General Election"
                  description={<>Release date: February 17, 2026
                    <br /><br />
                    Elections Nova Scotia – Chief Electoral Officer (CEO), Dorothy Rice, has released the final post-election report for the 42nd Provincial General Election (PGE) held on November 26, 2024. 
                    <br /><br />
                    The Report of the CEO on the proceedings of the PGE is presented in three volumes. Volume I, Statement of Votes & Statistics was released May 7, 2025. Volume II, Report on the Conduct of the November 26, 2024, Provincial General Election and Recommendations for Legislative Change, was released on September 11, 2025, and included lessons learned and legislative recommendations. 
                    <br /><br />
                    Today, Ms. Rice published Volume III, Financial Information and Statistics, in accordance with Section 163 of the Elections Act. The Volume III report provides financial information on election expenses, candidate reimbursement, election administration costs, and financial statistics. Elections Nova Scotia’s administrative costs for delivering the election are also detailed. Comparative statistics to previous provincial general elections are provided where appropriate. 
                    <br /><br />
                    The volume III report is available on the ENS website <a href="/files/GeneralElection_42nd/Volume3_Financial Information_February2026.pdf">Volume III</a>. 
                    <br /><br />
                    ENS is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit electionsnovascotia.ca or follow us on Facebook, X, Bluesky, and Instagram.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />
                   
                    Elections Nova Scotia
                    <br/>
                     <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>
                   
                   <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                  </>}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Elections Nova Scotia Presents 2026-2027 Budget Estimate to the Special Committee of the House of Assembly"
                  description={<>Release date:
                    January 15, 2026 <br /><br />On January 14, 2026, Li Chao, the Chief Financial Officer for Elections Nova Scotia (ENS) presented a budget...</>}
                  action={{
                    type: "internal",
                    route: "/budgetEstimate2026_2027",
                    label: "Read More",
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  color="info"
                  icon="info"
                  title="Elections Nova Scotia Annual Report 2024-2025"
                  description={<>Release date: November 03, 2025 
                    <br /><br />
                    Elections Nova Scotia – Elections Nova Scotia’s (ENS) Annual Report for the 2024–2025 fiscal year is now posted on the ENS website at <a href="https://www.electionsnovascotia.ca">https://www.electionsnovascotia.ca/</a>.
                    <br /><br />
                    The 2024-2025 fiscal year activity focused on executing the 42nd Provincial General Election. Over the twelve-month period, ENS worked steadily on election readiness projects and accelerated our planning when an early election call was anticipated. The annual report shows our progress towards our strategic goals and includes independently audited financial statements.  
                    <br /><br />
                    The annual report is available in English and French. 
                    <br /><br />
                    ENS is a non-partisan and independent agency responsible for conducting provincial elections.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Elections Nova Scotia
                    <br/>
                    <a href="mailto:elections@novascotia.ca"><i><b><u>elections@novascotia.ca</u></b></i></a>
                  </>}
                  // action={{
                  //   type: "internal",
                  //   route: "/PictouWestByElection",
                  //   label: "Read more",
                  // }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  color="info"
                  icon="info"
                  title="Report on the Conduct of the November 26, 2024, Provincial General Election and Recommendations for Legislative Change"
                   description={<>Release date: September 11, 2025 
                   <br /><br />
                    Elections Nova Scotia – Chief Electoral Officer (CEO), Dorothy Rice, has released the second volume of post-election reporting for the 42nd Provincial General Election (PGE) held on November 26, 2024. 
                   <br></br>
                   <br></br>
                   The Report of the CEO on the proceedings of the PGE is presented in three volumes. Volume I, Statement of Votes & Statistics was released May 7, 2025. Volume II, Report on the Conduct of the November 26, 2024, Provincial General Election and Recommendations for Legislative Change, is being released today. It includes lessons learned and legislative recommendations. Volume III, Financial Information and Statistics will be released later in 2025 and will provide financial information on election expenses, candidate reimbursement, election administration costs, and financial statistics.
                    <br></br>
                    <br></br>
                    The 11 recommendations for legislative change presented in the volume II report are grouped into three themes: Electoral Finance, Transparency, and Clarity. Each recommendation presented in the report includes a brief explanation as to why the CEO is proposing the change to be considered by Members of the House of Assembly. 
                   <br></br>
                   <br></br>
                   The recommendations were developed based on the post-election debriefs and feedback during the delivery of the 42nd PGE. The intent of the recommendations is to improve Nova Scotia’s electoral process to achieve the highest quality election administered in the province. Elections Nova Scotia (ENS) consulted with the Election Commission in the process of developing these recommendations. 
                   <br></br>
                   <br></br>
                   The report also includes background on the status of recommendations for legislative change made following the 41st PGE held in 2021. 
                   <br>
                  </br>
                  <br></br>
                  The volume II report is available on the ENS website at <a href="https://www.electionsnovascotia.ca">www.electionsnovascotia.ca </a>and is attached here in PDF format for your convenience. 
                   <br></br>
                   <br></br>
                   ENS is a non-partisan and independent agency responsible for conducting provincial elections. For more information, please visit electionsnovascotia.ca or follow us on Facebook, X, and Instagram @electionsns.
                   <br></br>
                   <br></br>
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />
                   
                    Elections Nova Scotia
                    <br/>
                     <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>
                   
                   <br></br>
                    902-424-3275
                    <br></br>
                    902-223-4871
                    
                    
                   </>
                   }
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  color="info"
                  icon="info"
                  title="Voter Registration Month"
                  description={<>Release date: September 08, 2025 
                    <br /><br />
                    Elections Nova Scotia – In honour of the International Day of Democracy, September 15, Elections Nova Scotia (ENS) is raising awareness about the voter registration process.
                    <br /><br />
                    While there is not currently an election pending, individuals may register to vote or update their electoral information at any time. Registering ahead of time ensures that voters are ready to participate in the electoral process whenever an election is called.  
                    <br /><br />
                    To register, voters may use the online tool available at www.electionsnovascotia.ca, email voter.registration@electionsnovascotia.ca, or call 1-800-565-1504 for assistance. Eligible voters need a valid form of ID with their current address and legal name to register. Those without ID can still vote during an election by taking an oath attesting to their eligibility. 
                    <br /><br />
                    To be on the Nova Scotia voters list and vote in a provincial election, you must be a Canadian citizen, be at least 18 years old or older, and have lived in Nova Scotia for at least six months.
                    <br /><br />
                    During an election, registered voters will receive a personalized Voter Information Card (VIC). VICs contain information about where and when to vote. Although you do not need to have a VIC or be registered to vote, registering before an election makes voting quick and efficient.
                    <br /><br />
                    ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>
                    <br />
                    902-424-3275
                  </>}
                  // action={{
                  //   type: "internal",
                  //   route: "/PictouWestByElection",
                  //   label: "Read more",
                  // }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  color="info"
                  icon="info"
                  title="2024 Political Donations Annual Report"
                  description={<>Release date:
                    June 26, 2025 <br /><br />
                    Elections Nova Scotia – Elections Nova Scotia (ENS) has published the Political Donations Annual Report for 2024, in accordance with Sections 240 and 251 of the Elections Act (the Act). 
                    <br /><br />
                    The report lists the name and community of each person who contributes $200 or more in the calendar year, and the amount of the donation to registered political parties, Electoral District Associations (EDAs), and registered candidates. An annual contribution limit of $5,000 to a party and its related entities or an independent candidate is in place. Only individuals who reside in Nova Scotia are permitted to contribute to a registered political entity. Publishing this information, as prescribed by the Act, helps to enhance transparency of the financial activities of those registered parties, EDAs, and candidates who are required to file. 
                    <br /><br />
                    It is not within the mandate of ENS to review the reports filed by political entities. However, if financial donations are not filed, political parties and EDAs run the risk of becoming deregistered. 
                    <br /><br />
                    The 2024 Political Donations Annual report is attached for your convenience and is also posted on the ENS website at electionsnovascotia.ca.
                    <br /><br />
                    ENS is a non-partisan and independent agency responsible for conducting provincial elections.
                    <br /><br />
                    <b>Media Contact:</b>	
                    <br />
                    Naomi Shelton
                    <br />
                    Director, Policy & Communications
                    <br />
                    <a href="mailto:Naomi.Shelton@novascotia.ca"><i><b><u>Naomi.Shelton@novascotia.ca</u></b></i></a>
                    <br />
                    902-424-3275
                  </>}
                  // action={{
                  //   type: "internal",
                  //   route: "/PictouWestByElection",
                  //   label: "Read more",
                  // }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  color="info"
                  icon="info"
                  title="Statement of Votes and Statistics Released for the 42nd Provincial General Election"
                  description={<>Release date:
                    April 30, 2025 <br /><br />
                    Elections Nova Scotia – Chief Electoral Officer, Dorothy Rice, has released the first volume of post-election reporting for the 42nd provincial general election held on November 26, 2024.
                    <br /><br />
                    The Statement of Votes & Statistics, Volume I report was submitted to the Legislative Assembly, in accordance with Section 163 of the Elections Act.
                    <br /><br />
                    The Report of the Chief Electoral Officer on the Proceedings of the 42nd provincial general election is presented in three volumes.
                    <br /><br />
                    Volume I, Statement of Votes & Statistics, released today, provides a summary of the election results and detailed statistics. The report is posted on Elections Nova Scotia’s website, please use the following link to access <a href="/files/GeneralElection_42nd/Volume1_Statistics_May2025.pdf">Volume I, Statement of Votes & Statistics.</a>
                    <br /><br />
                    Volume II, Report on the Conduct of the Election and Recommendations for Legislative Change, will include analysis of statistics provided in Volume I as well as my recommendations for changes to the Elections Act.
                    <br /><br />
                    Volume III, Financial Information and Statistics, will provide financial information on election expenses, candidate reimbursement, election administration costs and savings, as well as financial statistics.
                    <br /><br />
                    Volume II and Volume III will be released later this year.
                    <br /><br />
                    ENS is a non-partisan and independent agency responsible for conducting provincial elections.

                  </>}
                  // action={{
                  //   type: "internal",
                  //   route: "/PictouWestByElection",
                  //   label: "Read more",
                  // }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Elections Nova Scotia Presents 2025-2026 Budget Estimate to the Special Committee of the House of Assembly"
                  description={<>Release date:
                    January 30, 2025 <br /><br />On January 29, 2025, Li Chao, the Chief Financial Officer for Elections Nova Scotia (ENS) presented a budget...</>}
                  action={{
                    type: "internal",
                    route: "/budgetEstimate2025_2026",
                    label: "Read More",
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  color="info"
                  icon="info"
                  title="Pictou West By-election Financial Report"
                  description={<>Release date:
                    December 16, 2024 <br /><br />The Chief Electoral Officer (CEO) of Nova Scotia, Dorothy Rice, has released the financial report on the proceedings of the Pictou West by-election held on May 21, 2024. The report was submitted to the House of Assembly in accordance with Section 163 of the <em><a href="/files/ElectionsAct.pdf"><u>Elections Act</u></a></em>.</>}
                  action={{
                    type: "internal",
                    route: "/PictouWestByElection",
                    label: "Read more",
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Nova Scotians United Party Deregistration"
                  description={<>Release date:
                    December 12, 2024 <br /><br />The Chief Electoral Officer of Nova Scotia, Dorothy Rice, gives notice that effective December 10, 2024, that Nova Scotians United was deregistered as a political party in Nova Scotia under Section 186 of the <em><a href="/files/ElectionsAct.pdf"><u>Elections Act</u></a></em>.
                    <br />
                    <br />
                    Nova Scotians United did not endorse any nominated candidates for the 42nd provincial general election held on November 26, 2024.
                    <br />
                    <br />
                    ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
                  </>}
                // action={{
                //   type: "internal",
                //   route: "/budgetEstimate2025_2026",
                //   label: "Read More",
                // }}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <FilledInfoCard
                  //variant="gradient"
                  color="info"
                  icon="info"
                  title="Financial Reporting Deadlines for the 42nd Provincial General Election"
                  description={<>
                    Release date:
                    December 12, 2024
                    <br />
                    <br />Elections Nova Scotia reminds all nominated candidates, registered political parties, and third party advertisers from the 42nd provincial general election held on Tuesday, November 26, 2024, that financial reports are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.
                    <br />
                    <br />
                    Candidate tax receipts are due 30 days after election day, <b>December 30, 2024</b>.
                    <br />
                    <br />
                    Candidate financial reports, including audit reports, are due (80 days after writ) on <b>February 28, 2025</b>. It is also important to remember that there are <b>fines of $50 per day</b> for late candidate reports.
                    <br />
                    <br />
                    Registered party financial reports are due (120 days after Writ) on <b>April 9, 2025</b>.
                    <br />
                    <br />
                    Third party election advertising reports are due on <b>March 26, 2025</b>.
                    <br />
                    <br />
                    ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
                  </>}
                // action={{
                //   type: "internal",
                //   route: "/budgetEstimate2025_2026",
                //   label: "Read More",
                // }}
                />
              </Grid>
              {/* <Grid item xs={12} lg={12}>
              <FilledInfoCard
                //variant="gradient"
                color="info"
                icon="info"
                title="Recount Results – Electoral District 1 Annapolis"
                description={<>Release date:
                  December 10, 2024<br />
                  <br />A judicial recount of all ballots cast in electoral district 1 Annapolis for the 42nd provincial general election, was held on Tuesday, December 10, 2024. The...</>}
                action={{
                  type: "internal",
                  route: "/provincialGeneralElections",
                  label: "Read More",
                }}
              />
            </Grid> */}
            </Grid>
            <NewsInformation />
          </Container>

          {/* <Team />
        <Featuring />
        <Newsletter /> */}
        </Card>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </Box>
    </>
  );
}

export default News;
